/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Green_Horse_HikeInputs */

const en_vast_green_horse_hike = /** @type {(inputs: Vast_Green_Horse_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading file...`)
};

const de_vast_green_horse_hike = /** @type {(inputs: Vast_Green_Horse_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt wird hochgeladen...`)
};

/**
* | output |
* | --- |
* | "Uploading file..." |
*
* @param {Vast_Green_Horse_HikeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_green_horse_hike = /** @type {((inputs?: Vast_Green_Horse_HikeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Green_Horse_HikeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_green_horse_hike(inputs)
	return de_vast_green_horse_hike(inputs)
});